module.exports = __webpack_public_path__ + "static/downloable/calendario_pagos_RPP_2024.ac48782.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloable/calendario_pagos_RPP_2024.pdf
// module id = 5nKF
// module chunks = 1